import React, { useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";

const VideoPage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    {
      title: "MOU Signing Ceremony Between PANAH & RIC",
      description:
        "A milestone was achieved for needy and deserving patient by signing MOU between Rawalpindi Institute of Cardiology & Pakistan National Heart Association, through this platform needy patient can avail sponsorship for operations and cardiac treatment at RIC. Federal Minister for Railways, Mr. Hanif Abbasi was chief guest at this MOU signing occasion ceremony. President of Maj Gen (R) Masud Rehman Kiani, HI (M), and patron PANAH & Executive Director RIC, Dr. Musfireh Siddiqeh signed the agreement for better patient care.",
      src: "assets/video/mou-sign-panah-ric.mp4",
      thumbnail: "assets/thumbnails/mou-sign-panah-ric.png",
    }, 
    {
      title: "Security Department",
      description:
        "In RIC Security Department, serving as Security Officer with a team of 100+ trained guards working in 3 shifts to ensure safety. Our mission is to protect doctors, staff, equipment, and provide the best service to patients and attendants across ER, OPD, and wards.",
      src: "assets/video/security.mp4",
      thumbnail: "assets/thumbnails/security.png",
    },
    {
      title: "Radiology Department",
      description:
        "In RIC Radiology Department, we provide advanced general and cardiovascular imaging with digital X-ray, fluoroscopy, ultrasound, and CT scan. Our state-of-the-art Tesla MRI scanner enables us to perform high-quality MRI and cardiac imaging for better patient care",
      src: "assets/video/radiology.mp4",
      thumbnail: "assets/thumbnails/radiology.png",
    },
    {
      title: "Pathology Department",
      description:
        "RIC Pathology Department, serve’s 1,000–2,000 patients daily with advanced facilities including Hematology, Chemical Pathology, Microbiology, and a fully equipped Blood Bank.",
      src: "assets/video/path.mp4",
      thumbnail: "assets/thumbnails/path.png",
    },
    {
      title: "Inauguration of New OPD Ceremony",
      description:
        "For Patient Facilitation Rawalpindi Institute of Cardiology has established New Registration Counters which have been inaugurated by Federal Minister for Railways “Mr. Muhammad Hanif Abbasi” along with Executive Director RIC “Dr. Musfireh Siddiqeh and Medical Superintendent RIC “Dr. Abdul Malik Sheikh” on 13th August, 2025",
      src: "assets/video/inauguration.mp4",
      thumbnail: "assets/thumbnails/inauguration.png",
    },
  ];

  return (
    <main
      style={{
        fontFamily: "Segoe UI, sans-serif",
        backgroundColor: "#f5f5f5",
        paddingBottom: "40px",
      }}
    >
      {/* Breadcrumb */}
      <div
        style={{
          color: "white",
          boxShadow: "inset 0 0 0 2000px rgba(0, 0, 0, 0.4)",
        }}
      >
        <Breadcrumb title="Media" />
      </div>

      {/* Content Section */}
      <section
        style={{
          maxWidth: "1400px",
          margin: "50px auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "40px",
            borderRadius: "16px",
            boxShadow: "0 12px 24px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "2.2rem",
              color: "#b91c1c",
              textAlign: "center",
              marginBottom: "30px",
            }}
          >
            Media
          </h2>

          {/* ✅ Responsive Video Grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "20px",
            }}
          >
            {videos.map((video, index) => (
              <div
                key={index}
                style={{
                  background: "#fafafa",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  cursor: "pointer",
                  transition: "transform 0.3s",
                }}
                onClick={() => setSelectedVideo(video)}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.02)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover", // consistent thumbnails
                  }}
                />
                <div style={{ padding: "15px" }}>
                  <h3
                    style={{
                      fontSize: "1.25rem",
                      marginBottom: "10px",
                    }}
                  >
                    {video.title}
                  </h3>
                  <p style={{ fontSize: "0.95rem", color: "#555" }}>
                    {video.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ✅ Responsive Video Modal */}
      {selectedVideo && (
        <div
          onClick={() => setSelectedVideo(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "20px",
          }}
        >
          <div
            style={{
              maxWidth: "900px",
              width: "100%",
              background: "#fff",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
            }}
          >
            <video
              src={selectedVideo.src}
              controls
              autoPlay
              style={{
                width: "100%",
                maxHeight: "70vh", // responsive video height
                background: "#000",
              }}
            />
            <div style={{ padding: "20px" }}>
              <h2>{selectedVideo.title}</h2>
              <p>{selectedVideo.description}</p>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default VideoPage;
